import { createSelector } from 'reselect';
import { values } from 'ramda';
import { SearchSelector } from './search.selectors';
import { getSearchFieldsTemplate } from '../../components/search/search.constants';
import { generateTitle } from '../../components/giftCard/gift.card.helper';
var GiftCardSearchSelector = createSelector([SearchSelector], function (search) {
  return search.giftCards;
});
export var GiftCardSearchMapSelector = createSelector([GiftCardSearchSelector], function (giftCards) {
  var giftCardMap = {};
  giftCards.data.forEach(function (giftCard) {
    var gc = Object.assign({}, giftCard);
    gc.title = generateTitle(giftCard);
    giftCardMap[giftCard.Id] = gc;
  });
  return giftCardMap;
});
export var GiftCardSearchArraySelector = createSelector([GiftCardSearchMapSelector], function (giftCardSearchMap) {
  return giftCardSearchMap ? values(giftCardSearchMap) : null;
});
export var GiftCardSearchRecordCountSelector = createSelector([GiftCardSearchSelector], function (giftCards) {
  return giftCards.recordCount;
});
export var GiftCardSearchCurrentPageNumberSelector = createSelector([GiftCardSearchSelector], function (giftCards) {
  return giftCards.pageNumber;
});
export var GiftCardSearchTotalPageCountSelector = createSelector([GiftCardSearchSelector], function (giftCards) {
  return giftCards.pageCount;
});
var recoverableUIStateSelector = function recoverableUIStateSelector(state) {
  return state.customercare.recoverableUiState.searchGiftCards.giftCardSearchModel;
};
export var GiftCardSearchModelSelector = createSelector([recoverableUIStateSelector], function (state) {
  return state ? state : getSearchFieldsTemplate();
});